var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.825 4.317C11.251 2.561 13.749 2.561 14.175 4.317C14.3046 4.85206 14.682 5.29302 15.1907 5.50375C15.6993 5.71447 16.2779 5.6696 16.748 5.383C18.291 4.443 20.058 6.209 19.118 7.753C18.8318 8.22285 18.7871 8.80108 18.9975 9.30938C19.208 9.81768 19.6484 10.195 20.183 10.325C21.939 10.751 21.939 13.249 20.183 13.675C19.6479 13.8046 19.207 14.182 18.9963 14.6907C18.7855 15.1993 18.8304 15.7779 19.117 16.248C20.057 17.791 18.291 19.558 16.747 18.618C16.2771 18.3318 15.6989 18.2871 15.1906 18.4975C14.6823 18.708 14.305 19.1484 14.175 19.683C13.749 21.439 11.251 21.439 10.825 19.683C10.6954 19.1479 10.318 18.707 9.80935 18.4963C9.30073 18.2855 8.72206 18.3304 8.252 18.617C6.709 19.557 4.942 17.791 5.882 16.247C6.16819 15.7771 6.21295 15.1989 6.00247 14.6906C5.792 14.1823 5.35157 13.805 4.817 13.675C3.061 13.249 3.061 10.751 4.817 10.325C5.35206 10.1954 5.79302 9.81797 6.00375 9.30935C6.21447 8.80073 6.1696 8.22206 5.883 7.752C4.943 6.209 6.709 4.442 8.253 5.382C9.253 5.99 10.549 5.452 10.825 4.317Z",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 9V15L15.5 12L10.5 9Z",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortVideo);
export default __webpack_public_path__ + "static/media/sortVideo.67ea6afe5b0c658df4d88c6457a640b3.svg";
export { ForwardRef as ReactComponent };